define.alias("ember-functions-as-helper-polyfill/initializers/usable-function-manager", "settings/initializers/usable-function-manager");